export const normalizeTag = (tag: string): string => {
    const trimmedTag = tag.trim();
    return trimmedTag.startsWith('#') ? trimmedTag : `#${trimmedTag}`;
};

export const normalizeTags = (tags: string[]): string[] => tags.map(normalizeTag);
